import { render, staticRenderFns } from "./exp-score.vue?vue&type=template&id=c2304a2e&scoped=true"
import script from "./exp-score.vue?vue&type=script&lang=js"
export * from "./exp-score.vue?vue&type=script&lang=js"
import style0 from "./exp-score.vue?vue&type=style&index=0&id=c2304a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2304a2e",
  null
  
)

export default component.exports